import { AudioResource } from '@ilteducation/videos';
import { defineStore } from 'pinia';
import { ref } from 'vue';

const useAudioStore = defineStore('audio', () => {
  const audioResources = ref<AudioResource[]>([]);
  const isNarrationAudioPlaying = ref(false);

  const addAudioResources = (audioResource: AudioResource) => {
    audioResources.value.push(audioResource);
  };

  const updateAudioResourceUrl = (audioResource: AudioResource) => {
    audioResources.value.forEach((el) => {
      if (el.id === audioResource.id) {
        el.url = audioResource.url;
      }
    });
  };

  const setNarrationPlaying = (isPlaying: boolean) => {
    isNarrationAudioPlaying.value = isPlaying;
  };

  return {
    audioResources,
    isNarrationAudioPlaying,
    setNarrationPlaying,
    addAudioResources,
    updateAudioResourceUrl,
  };
});

export default useAudioStore;
